<template>
  <v-form ref="form" class="">
    <!-- <v-alert
      type="info"
      elevation="2"
      v-if="partialReadOnly"
      dismissible
      class="mt-2"
    >
      Esta conta a pagar já possui parcelas pagas, por isso você pode editar somente o plano de contas dela.
      Caso queira editar a conta, você deve cancelar o pagamento de todas as parcelas pagas dessa conta.
    </v-alert> -->

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="entry.code"
          v-bind="getObject('code')"
          label="Código"
          :disabled="editOnly || paymentConfirmation || readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" sm="8">
        <v-text-field
          v-if="entry.payment.cashFlow.customer"
          v-model="entry.payment.cashFlow.customer.name"
          v-bind="getObject('payment.cashFlow.customer.name')"
          label="Fornecedor"
          :disabled="editOnly || paymentConfirmation || readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <DateField
          :inputData.sync="entry.dueDate"
          v-bind="getObject('dueDate')"
          label="Data de Vencimento"
          :hasTodayButton="true"
          :hasTodayDate="true"
          :disabled="(!editOnly || paymentConfirmation || readOnly)"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" sm="6" md="3" v-if="!editOnly || paymentConfirmation">
        <DateField
          :inputData.sync="entry.paymentDate"
          v-bind="getObject('paymentDate')"
          label="Data de Recebimento"
          :hasTodayButton="true"
          :hasTodayDate="true"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <v-text-field
          v-if="entry.payment.cashFlow.chart"
          v-model="entry.payment.cashFlow.chart.name"
          v-bind="getObject('payment.cashFlow.chart.name')"
          label="Plano de Contas"
          :disabled="editOnly || paymentConfirmation || readOnly"
          autocomplete="off"
          inputmode="none"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="entry.paymentMethod.id"
          v-bind="getObject('paymentMethod.id')"
          :label="'Forma de recebimento'"
          :items="extraData.globalContext.allGlobalPaymentMethods"
          @input="selectPaymentMethod"
          item-value="id"
          item-text="name"
          autocomplete="off"
          :disabled="readOnly || paymentConfirmation"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <v-autocomplete
          :disabled="readOnly || paymentConfirmation"
          v-model="entry.bankAccountId"
          v-bind="getObject('bankAccountId')"
          label="Conta Bancária"
          :items="bankAccountsList"
          @input="selectBankAccount"
          item-value="id"
          item-text="nameWithBank"
          :hint="entry.bankAccountId ? ('Saldo Atual: ' + numberToCurrency(entry.bankAccount.currentBalance) + ', Tipo: ' + (entry.bankAccount.bankAccountType ? entry.bankAccount.bankAccountType.name : '') + (entry.bankAccount.agencyNumber ? ' - Agência: ' + entry.bankAccount.agencyNumber : '') + (entry.bankAccount.agencyNumber ? ' - Número: ' + entry.bankAccount.accountNumber : '')) : '' "
          persistent-hint
          autocomplete="new"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.nameWithBank}}</v-list-item-title>
              <v-list-item-subtitle>
                Saldo Atual: <strong>{{numberToCurrency(data.item.currentBalance)}}</strong>,
                Tipo: {{data.item.bankAccountType ? data.item.bankAccountType.name : ''}}
                {{data.item.agencyNumber ? '- Agência: ' + data.item.agencyNumber : ''}}
                {{data.item.agencyNumber ? '- Número: ' + data.item.accountNumber : ''}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>

          <template v-slot:append-outer>
            <BankAccountNew
              :inlineAddButton="true"
              @entry-created="bankAccountCreated"
              modelNameSingular="Conta Bancária"
            />
          </template>
        </v-autocomplete>
      </v-col>



      <!-- <v-col cols="3">
        <MaskedTextField
          v-bind="getObject('originalValue')"
          :inputData.sync="entry.originalValue"
          mask-type="currency"
          label="Valor da Parcela"
          :disabled="editOnly || paymentConfirmation || readOnly"
        />
      </v-col> -->

      <v-col cols="12">
        <div class="title mt-3">
          Valor da Parcela:
          <b class="headline black--text font-weight-bold ml-2"> {{entry.originalValue | formatCurrency}} </b>
        </div>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <MaskedTextField
          v-bind="getObject('paidAmount')"
          :inputData.sync="entry.paidAmount"
          mask-type="currency"
          label="Valor Recebido (Capital)"
          :disabled="editOnly || readOnly"
          @update:inputData="calculateTotalValue"
          autocomplete="off"
        >
          <template slot="prependMask">
            <v-tooltip top color="info">
              <template v-slot:activator="{ on, attrs }" >
                <v-icon
                  color="info"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              <span>
                Esse valor é referente somente ao valor da parcela, sem considerar juros, multa e desconto.
              </span>
            </v-tooltip>
          </template>
        </MaskedTextField>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <MaskedTextField
          v-bind="getObject('interest')"
          :inputData.sync="entry.interest"
          mask-type="currency"
          label="Juros"
          prefix="R$"
          persistent-hint
          :disabled="editOnly || readOnly"
          @update:inputData="calculateTotalValue"
          autocomplete="off"
        >
          <template slot="prependMask">
            <v-icon>mdi-plus</v-icon>
          </template>
        </MaskedTextField>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <MaskedTextField
          v-bind="getObject('penalty')"
          :inputData.sync="entry.penalty"
          mask-type="currency"
          label="Multa"
          prefix="R$"
          persistent-hint
          :disabled="editOnly || readOnly"
          @update:inputData="calculateTotalValue"
          autocomplete="off"
        >
          <template slot="prependMask">
            <v-icon>mdi-plus</v-icon>
          </template>
        </MaskedTextField>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <MaskedTextField
          v-bind="getObject('discount')"
          :inputData.sync="entry.discount"
          mask-type="currency"
          label="Desconto"
          prefix="R$"
          :disabled="editOnly || readOnly"
          @update:inputData="calculateTotalValue"
          autocomplete="off"
        >
          <template slot="prependMask">
            <v-icon>mdi-minus</v-icon>
          </template>
        </MaskedTextField>
      </v-col>


      <v-col cols="12" sm="12" md="6">
        <div class="title mt-3">
          <v-tooltip top color="info">
            <template v-slot:activator="{ on, attrs }" >
              <v-icon
                color="info"
                dark
                v-bind="attrs"
                v-on="on"
              >
                mdi-information-outline
              </v-icon>
            </template>
            <span>
              Esse valor é referente ao valor recebido da parcela, somando juros e multa e subtraindo o desconto.
            </span>
          </v-tooltip>

          Valor Final Recebido:
          <b class="headline black--text font-weight-bold ml-2"> {{installmentTotalPrice | formatCurrency}} </b>
        </div>
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <div
          v-if="entry.paidAmount < entry.originalValue || entry.isPartiallyPaid"
          class="title mt-3"
        >
          Recebimentos Adicionais:
          <!-- <b class="headline black--text font-weight-bold ml-2"> {{totalPayment | formatCurrency}} </b> -->
          <b class="headline black--text font-weight-bold ml-2"> {{ (entry.originalValue - entry.paidAmount) | formatCurrency}} </b>
        </div>
      </v-col>

    
      <!-- <v-col cols="4">
        <div
          v-if="entry.paidAmount < entry.originalValue || entry.isPartiallyPaid"
          class="title mt-3"
        >
          Restante a ser recebido:
          <b :class="'headline black--text font-weight-bold ml-2 ' + (remaining > 0 ? 'red--text' : 'green--text')"> {{remaining | formatCurrency}} </b>
        </div>
      </v-col> -->

      <v-col cols="12" class="">
        <PaymentIndex
          v-if="entry.paidAmount < entry.originalValue || entry.isPartiallyPaid"
          :payments="entry.additionalPaymentsAttributes"
          :paymentLimit="remaining + totalPayment"
          :readOnly="readOnly"
          modelType="CashInflowInstallment"
          :totalPayment.sync="totalPayment"
          @update:totalPayment="calculateTotalValue"
          :hasTableTitle="true"
          tableTitle="Recebimentos Adicionais"
          @installment-update="$emit('installment-update', $event)"
        />
      </v-col>

      <v-col cols="12">
        <v-textarea
          v-model="entry.observation"
          v-bind="getObject('observation')"
          label="Observações"
          outlined
          :readonly="readOnly"
          autocomplete="off"
        ></v-textarea>
      </v-col>

      <v-col cols="12">
        <v-textarea
          v-model="entry.parentObservation"
          v-bind="getObject('parentObservation')"
          label="Observações da Origem da Parcela"
          outlined
          :readonly=true
          autocomplete="off"
        ></v-textarea>
      </v-col>

    </v-row>

  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue"
import PaymentIndex from "@models/payments/index.vue"
import ChartOfAccountSelect from "@models/chart_of_accounts/select.vue"
import BankAccountNew from "@models/bank_accounts/new.vue"
import BaseUtil from "@shared_components/base_util.vue"
import gql from 'graphql-tag';


export default {
  data() {
    return {
      entryAttributes: {},
      totalPayment: 0,
      selectedChartOfAccountName: null,
      installmentTotalPrice: 0,
      remaining: 0,
      pageLoading: false,
      bankAccountsList: [],
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    editOnly: {
      type: Boolean,
      default: false
    },
    paymentConfirmation: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    DateField: DateField,
    PaymentIndex: PaymentIndex,
    ChartOfAccountSelect: ChartOfAccountSelect,
    BankAccountNew: BankAccountNew,
    BaseUtil: BaseUtil
  },
  created() {
    // console.log("conf", this.paymentConfirmation);
    this.entry.validations = this.entry.fullPaymentValidations;
    this.entryAttributes = this.setupEntryAttributes(this.entry);

    // this.entryAttributes.paidAmount.rules.push(this.requiredRule);
    // this.entryAttributes.paidAmount.rules.push(this.minRequiredRule);
    this.entryAttributes.paidAmount.rules.push(this.maxCurrencyRule(this.entry.originalValue));
    this.entryAttributes.paidAmount.hint = "Valor máximo de " + this.numberToCurrency(this.entry.originalValue);

    this.entryAttributes.discount.rules.push(this.maxCurrencyRuleAllowZero(this.entry.originalValue));
    this.entryAttributes.discount.hint = "Valor máximo de " + this.numberToCurrency(this.entry.originalValue);

    if (this.entry.isFullyPaid || this.entry.isPartiallyPaid){
      this.totalPayment = this.entry.additionalPaymentsAttributes.reduce(((a, b) => a + b['value']), 0)
      // console.log("calculou this.totalPayment", this.totalPayment);
    } else {
      this.entry.paidAmount = this.entry.originalValue;
    }
    this.calculateTotalValue();

    this.bankAccountsList = this.extraData.accountContext.allBankAccountsForInstallment;
    // console.log("extra", this.extraData.accountContext.allBankAccountsForInstallment)
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    calculateTotalValue: function() {
      this.installmentTotalPrice = this.entry.paidAmount + this.entry.interest + this.entry.penalty - this.entry.discount;
      this.remaining = this.entry.originalValue - this.entry.paidAmount - this.totalPayment;
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    selectBankAccount: function() {
      this.entry.bankAccount = this.bankAccountsList.find(obj => obj.id == this.entry.bankAccountId);
    },
    selectPaymentMethod: function(){
      // this.editableEntry = null;
      this.error = null;
      // this.loading = true;
      this.$apollo
        .query({
          query: ALL_BANK_ACCOUNTS_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            paymentMethodId: this.entry.paymentMethod.id
          }
        })
        .then(response => {
          this.bankAccountsList = response.data.accountContext.allBankAccountsNoInvestments;
          // this.extraData = response.data;
          // if (this.editableEntry.canBeDeleted === false) {
          //   this.partialReadOnly = true;
          // }
          // console.log("cashInflowInstallment edit", this.editableEntry);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    bankAccountCreated: function(bankAccount) {
      this.extraData.accountContext.allBankAccountsForInstallment.unshift(bankAccount);
      this.entry.bankAccountId = bankAccount.id;
      this.entry.bankAccount = bankAccount;
    },
  }
};


const ALL_BANK_ACCOUNTS_QUERY = gql `
  query ($paymentMethodId: ID!) {
    accountContext {
      allBankAccountsNoInvestments(paymentMethodId: $paymentMethodId) {
        id
        name
        nameWithBank
        currentBalance
        accountNumber
        agencyNumber
        bankAccountType {
          id
          name
        }
        bank {
          id
          name
          nameWithCode
        }
      }
    }
  }
`;

</script>

<style scoped>
  ::v-deep .enabledTextFieldChartOfAccount input {
    cursor: pointer;
  }
</style>
